<template>
    <div class="naw">
        <template v-if="isVersion2" >
            <h2 class="fatter">Goed gespeeld!</h2>
            <p>Vul je gegevens in en maak gratis kans op
                <template v-for="(item, index) of numBonuses">
                    <template><span v-html="item.name"></span><template>{{ index + 2 < numBonuses.length ? ', ' : ( index < numBonuses.length - 1 ? ' en ' : '' ) }}</template></template>
                </template>!
            </p>
        </template>
        <template v-else>
            <h2 class="fatter">Goed gespeeld!</h2>
            <p >Vul je gegevens in om kans te maken op&nbsp;<span><strong>&euro;&nbsp;{{ dottify( money ) }}</strong>!</span></p>
        </template>
        <v-form @complete="toResult" ref="customForm"></v-form>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { dottify } from '@/app/mixins';
    import Form from '@/app/components/Form';

    export default {
        components: {
            'v-form': Form
        },

        mixins: [ dottify ],

        data()
        {
            return {
                prizeNames: [ '1&nbsp;van&nbsp;de&nbsp;5&nbsp;Rituals&nbsp;Pakketten', 'een&nbsp;Sonos&nbsp;Beam', 'een&nbsp;Sonos&nbsp;Play&nbsp;1', '1&nbsp;van&nbsp;de&nbsp;4&nbsp;Apple&nbsp;iPads', '1&nbsp;van&nbsp;de&nbsp;3&nbsp;LG&nbsp;TV’s' ]
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            },

            money()
            {
                return this.$store.getters[ 'game/score' ];
            },

            bonuses()
            {
                return this.$store.getters[ 'game/bonuses' ];
            },

            numBonuses()
            {
                let arr = [];

                for( let i = 0; i < this.bonuses.length; i++ )
                {
                    if( this.bonuses[i] === 1 )
                    {
                        arr.push({
                            index: i,
                            name: this.prizeNames[i]
                        });
                    }
                }

                return arr;
            }
        },

        methods: {
            toResult()
            {
                this.$router.replace( '/bedankt' );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Naw.vue